export const InternalTransferRoutesPaths = {
  INTERNAL_TRANSFER: '/internal-transfer',
  OTP: '/internal-transfer-otp',
  SUCCESS: '/internal-transfer-success'
};
